import { ServiceDirectory } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';
import { servicesDirectoriesService } from '@services/requests/servicesService/servicesDirectoriesService';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * ServicesPathProcessor восстанавливает директории доп. услуг.
 */
export class ServicesPathProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет генерацию стейта по полям и услугам. Возвращает сам стейт.
   * @param setUpServiceData
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    setUpServiceData: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const servicesPath = Object.values(setUpServiceData.ServicesPath);
    const servicesPathIds = servicesPath.map((s) => s.id);
    const servicesPathLength = servicesPathIds.length;

    const loadedPathServices = await servicesDirectoriesService().GetServiceByIDS(servicesPathIds);
    loadedPathServices.sort((a, b) => {
      return servicesPathIds.indexOf(a.id) - servicesPathIds.indexOf(b.id);
    });

    const newServicesPath: { [T in string]: ServiceDirectory } = {};

    for (let i = 0; i < servicesPathIds.length; i++) {
      const loadedService = loadedPathServices[i];
      const isSaveService = loadedService.id === servicesPath[i].id;

      if (!loadedService || !loadedService.is_active || !isSaveService) {
        break;
      }

      newServicesPath[i] = loadedService;
    }

    const lastDirectory = newServicesPath[Object.values(newServicesPath).length - 1];
    const loadedDirectoriesCache = Object.fromEntries(
      Object.values(newServicesPath).map((dir) => [dir.id, dir])
    );

    let isLastLevelSelected = false;

    if (!!lastDirectory) {
      isLastLevelSelected = lastDirectory.children.length === 0;

      if (lastDirectory.is_variants) {
        isLastLevelSelected = lastDirectory.children.filter((c) => c.is_active).length > 0;
      }
    }

    return {
      isValid: servicesPathLength === Object.values(newServicesPath).length,
      additionalServiceState: {
        ...additionalServiceState,
        ServicesPath: newServicesPath,
        LastServiceInPath: lastDirectory,
        LoadedDirectoriesCache: loadedDirectoriesCache,
        IsLastLevelSelected: isLastLevelSelected,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
